/**
 * 月曆操作
 */
export default {
    computed: {
        calendar() {
            return this.$store.state.calendar.calendar
        }
    },
    methods: {
        calendarRest() {
            this.$store.commit('calendar/calendarRest')
        },
        calendarNext() {
            this.$store.commit('calendar/calendarNext')
        },
        calendarBack() {
            this.$store.commit('calendar/calendarBack')
        }
    }
}



// WEBPACK FOOTER //
// ./src/delegate/calendarDelegate.js